import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'calc(100% - 1px)',
    height: '35px',
    backgroundColor: '#FFFFFF',
    zIndex: 10,
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  header: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    color: '#000000',
    padding: '10px',
  },
  dropdown: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    color: '#2C2D3E',
    padding: '10px',
  },
}));
